import { FC } from 'react';

import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

export const ShelfDetailSkeleton: FC<{ className?: string }> = ({
  className,
}: {
  className?: string;
}) => (
  <div className={cn('flex flex-col gap-3 overflow-hidden', className)}>
    <Skeleton className='h-10 w-full max-w-xl shrink-0' />
    <div className='flex min-h-0 flex-1 gap-3 lg:flex-row'>
      <Skeleton className='min-h-0 flex-1 rounded-xl' />
      <Skeleton className='hidden w-80 shrink-0 rounded-xl lg:block' />
    </div>
    <Skeleton className='h-36 shrink-0 rounded-xl' />
  </div>
);
